import request from '@/router/axios'
// 等级测试记录
export function GetTestRecordsList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetTestRecordsList',
        method: 'post',
        data: query
    })
}
// 查看成绩
export function GetAthleteTestScoreList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetAthleteTestScoreList',
        method: 'post',
        data: query
    })
}
//申诉
export function CreateAthleteAppeal(query) {
    return request({
        url: '/api/services/app/AthleteCenter/CreateAthleteAppeal',
        method: 'post',
        data: query
    })
}
//二次申诉
export function UpdateAthleteSSAppeal(query) {
    return request({
        url: '/api/services/app/TestOrg/UpdateAthleteSSAppeal',
        method: 'post',
        data: query
    })
}
//申诉记录
export function getAthleteTestData(query) {
    return request({
        url: '/api/services/app/TestOrg/getAthleteTestData',
        method: 'post',
        data: query
    })
}
// 赛事申请列表(自动)
export function GetEventAthleteList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetEventAthleteList',
        method: 'post',
        data: query
    })
}
// 赛事申请(自动)
export function GetEventsAthleteApplyList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetEventsAthleteApplyList',
        method: 'post',
        data: query
    })
}
// 赛事申请列表(手动)
export function GetEventsList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetEventsList',
        method: 'post',
        data: query
    })
}
// 赛事申请(手动)
export function GetManualApplicationList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetManualApplicationList',
        method: 'post',
        data: query
    })
}
// 赛事申请记录
export function GetEventsApplyList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetEventsApplyList',
        method: 'post',
        data: query
    })
}
// 发票
export function GetInvoiceRecordsList(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetInvoiceRecordsList',
        method: 'post',
        data: query
    })
}
// 发票详情
export function GetPaymentOrderInvoice(query) {
    return request({
        url: '/api/services/app/AthleteCenter/GetPaymentOrderInvoice',
        method: 'post',
        data: query
    })
}

// 测试报名详情接口
export function TestApplicationList(query) {
    return request({
        url: '/api/services/app/TestApplication/TestApplicationList',
        method: 'post',
        data: query
    })
 }

//是否存在补考
export function CheckExistRetake() {
    return request({
        url: '/api/services/app/TestApplication/CheckExistRetake',
        method: 'post',
    })
}

//修改补考
export function UpdateRetakeFlag(applicationId) {
    return request({
        url: '/api/services/app/TestApplication/UpdateRetakeFlag',
        method: 'post',
        data: {applicationId}
    })
}


 //报名接口
 export function TestClassSignUp(query) {
    return request({
        url: '/api/services/app/TestApplication/TestClassSignUp',
        method: 'post',
        data: query
    })
 }

  //订单展示详情接口
  export function TestClassSettlementDetails(query) {
    return request({
        url: '/api/services/app/TestApplication/TestClassSettlementDetails',
        method: 'post',
        data: query
    })
 }
 // 测试报名等级
export function GetTestGradeList(query) {
    return request({
        url: '/api/services/app/TestClass/GetTestGradeList',
        method: 'post',
        data: query
    })
 }

// 设置前端是否展示运动员的证书证章
export function SetOpenQuery(query) {
    return request({
        url: '/api/services/app/CommonApi/SetOpenQuery',
        method: 'post',
        data: query
    })
}

// 获取前端是否展示运动员的证书证章
export function GetOpenQuery(query) {
    return request({
        url: '/api/services/app/CommonApi/GetOpenQuery',
        method: 'post',
        data: query
    })
}
//运动员列表
export function GetAthleteList(query) {
    return request({
        url: '/api/services/app/CommonApi/GetAthleteList',
        method: 'post',
        data: query
    })
}
